/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_TInputs */

const en_tut_jadwal_t = /** @type {(inputs: Tut_Jadwal_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal schedule and reminders`)
};

const id_tut_jadwal_t = /** @type {(inputs: Tut_Jadwal_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal internal dan pengingat`)
};

/**
* | output |
* | --- |
* | "Internal schedule and reminders" |
*
* @param {Tut_Jadwal_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_t = /** @type {((inputs?: Tut_Jadwal_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_t(inputs)
	return en_tut_jadwal_t(inputs)
});